import { createStyles, makeStyles } from '@material-ui/core/styles';
import { StyleRules } from '@material-ui/styles/withStyles';
import { COLORS } from 'src/styles/colors';

export const useStyles = makeStyles(
  (): StyleRules =>
    createStyles({
      positive: {
        color: COLORS.green['500'],
      },
      negative: {
        color: COLORS.red['500'],
      },
      none: {
        color: COLORS.black,
      },
    })
);
